import React, { Fragment, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, IconButton, Typography } from '@material-ui/core';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import { ContentSharePreviewFragment } from 'api';
import ActionButtons from './ActionButtons';

interface IProps extends WithStyles<typeof styles> {
  shareCount: number;
  previewInfo: ContentSharePreviewFragment;
  onClose: () => void;
}

const styles = (theme: Theme) =>
  createStyles({
    backButton: {
      position: 'absolute',
      left: theme.spacing(4),
      padding: 6,
      marginTop: theme.spacing(0.5),
      backgroundColor: theme.custom.palette.grey3,
      color: theme.custom.palette.black2,

      '&:hover': {
        backgroundColor: theme.custom.palette.grey2,
        color: theme.custom.palette.black1,
      },
    },
  });

const Heading: FC<IProps> = ({ classes, previewInfo, onClose, shareCount }) => {
  const { t } = useTranslation();
  const { shortened_urls } = previewInfo;

  return (
    <Fragment>
      <IconButton className={classes.backButton} onClick={onClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Typography color="inherit" variant="h4">
            {t('sharing:dialogTitle')}
          </Typography>
        </Grid>
        <Grid item>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <Typography>{t('content:xShare', { count: shareCount || 0 })}</Typography>
            </Grid>
            <Grid item>
              <ActionButtons shortenedUrls={shortened_urls} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default withStyles(styles)(Heading);
